export enum PRODUCT_STATUS {
	OUT_OF_STOCK = 'outOfStock',
	AVAILABLE = 'available',
	RETURNED = 'returned',
	RETURN_REQUESTED = 'returnRequested',
}

export const PRODUCT_STATUS_LABELS = {
	[PRODUCT_STATUS.RETURNED]: 'myPurchases.online.oneReturnedItem.label',
	[PRODUCT_STATUS.RETURN_REQUESTED]:
		'myPurchases.online.status_return_requested.label',
	[PRODUCT_STATUS.OUT_OF_STOCK]:
		'myPurchases.online.details.productOutStock.label',
}
